import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Returns true if the given year (number, string, or ISO date string) is a leap year.
 * Throws for invalid input.
 */
export function isLeapYear(input: IsoDate | IsoDateTime | IsoDateTimeTz): boolean {
  const {year} = deconstructDate(input);
  if(!year || isNaN(year) || year < 0) {
    throw new Error(`isLeapYear(): Invalid year extracted from input: ${input}`);
  }
  // Leap year rule
  return (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
}

